import { useCallback, useState } from "react";

import { fetchGraphQL } from "../gql.client";
import { getSubscriptionQuery } from "../gql.queries";

import type { Plan } from "../../../types/Plan.type";
import type { UseUserHook } from "../../../types/User.type";

export const useUser = (): UseUserHook => {
    const [error, setError] = useState<string | null>(null);

    const getUser = useCallback(async () => {
        setError(null);

        try {
            const response = await fetchGraphQL({
                url: process.env.REACT_APP_SUBSCRIPTION_API_URL + '/graphql/user',
                query: getSubscriptionQuery()
            });

            if (response.error) {
                setError(response.error as string);
            } else {
                if (response?.data) {
                    const user = response?.data?.user[0];
                    const plans = response?.data?.plans as Plan[];
                    const userPlan = plans.find((plan) => plan.id === user.plan_id)

                    return {
                        user,
                        userPlan
                    }
                }
            }
        } catch (error) {
            console.log('response.error', error)
        }
    }, []);

    return {
        error,
        getUser,
    }
};